// extracted by mini-css-extract-plugin
export default {"section":"InlineError_section__qOjF8","icon":"InlineError_icon__DJVSA"};